import React from 'react';
import { colors } from '../../theme';

export default function EmptyState({ icon: Icon, text, sub }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '48px 20px', gap: 8 }}>
      {Icon && <Icon size={48} color={colors.gray300} strokeWidth={1.5} />}
      <span style={{ fontSize: 15, color: colors.gray400 }}>{text}</span>
      {sub && <span style={{ fontSize: 13, color: colors.gray300 }}>{sub}</span>}
    </div>
  );
}
